import InitializationError from "./InitializationError";

export default InitializationError;
